import React from 'react'
import './guideTo.scss'

const guideTo = props => {
	const { guideInfo, isCentered = true, colorPrincipal = '' } = props

	return (
		<div className={`a-guide-to ${!isCentered ? ' f-guide-start' : ''}`}>
			<div className='a-guide-to__title'>
				<h3>Dirigido a:</h3>
			</div>
			<div className='a-guide-to__cardContainer'>
				{guideInfo &&
					guideInfo.map((el, index) => (
						<div className='a-guide-to__cardContainer-card' key={index}>
							<div className='a-guide-to__cardContainer-card-img'>
								<img src={el.imagen.file.url} alt='' />
							</div>
							<div className='a-guide-to__cardContainer-card-subtitle'>
								<p style={{ color: colorPrincipal }}>{el.nombreDeEtiqueta}</p>
							</div>
						</div>
					))}
			</div>
		</div>
	)
}

export default guideTo
